export const API = process.env.REACT_APP_API_URL || "";

export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || "";

export const googleApiKey = process.env.REACT_APP_GOOGLE_KEY || "";

